module.exports = __webpack_public_path__ + "img/txt-only.53276490.jpg";